import { render } from "./wmsos-saida-editar-nova.vue?vue&type=template&id=b3a69c84&scoped=true"
import script from "./wmsos-saida-editar-nova.vue?vue&type=script&lang=js"
export * from "./wmsos-saida-editar-nova.vue?vue&type=script&lang=js"

import "./wmsos-saida-editar-nova.vue?vue&type=style&index=0&id=b3a69c84&scoped=true&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3a69c84"]])

export default __exports__